export const BASE_URL = import.meta.env.VITE_API_URL

export const routes = {
  home:'/',
  registration:'/registration',
  kitAward:'/kit-award',
  kitAwardId:'/kit-award/:id',
  speakers:'/speakers',
  notFound:'*'
}

export const navigation = [
  { id:'about-forum', title:'navigation.forum' },
  { id:'program', title:'navigation.program' },
  { id:'speakers', title:'navigation.speakers' },
  { id:'contacts', title:'navigation.contacts' }
]

export const options = [
  { value:'ru', title:'Русский' },
  { value:'en', title:'English' },
  { value:'ky', title:'Кыргызча' }
]

export const inputFields = [
  { type: 'text',name: 'fullName',label: 'form.fullName' },
  { type: 'email',name: 'email',label: 'example@domain.com' },
  { name: 'phone',label: 'form.number' },
]